import * as config from 'config';
import session from 'lib/session';
import { field } from 'redux/shelf';
import { del, get, post, put } from 'redux/shelf/api';
import { createReducer } from 'redux/shelf/reducer';

const useLegacyAdminInstragramOAuth = config.adminApiLegacy.instagramOAuth;

export const actions = {
  fetchList: get`content-integrations`(),
  create: post`content-integrations`((integration) => ({
    integration,
    fields: [],
  })),
  update: put`content-integrations/:id`(),
  del: del`content-integrations/:id`(),
  deleteContents: del`content-integrations/:id/content`(),
  fetch: get`content-integrations/:id`(({ fields, ...rest }) => ({
    integration: rest,
    fields,
  })),
  fetchAvailable: get`content-integrations/available-types`(field('available')),
  fetchInstagramAuthUrl: get`/meta/oauth/${session.getMerchant}/login`(
    field('instagramAuthUrl')
  ),
  updateField: put`content-integrations/:ciId/fields/:id`(),
  triggerContentJob: post`content-integrations/:id/trigger`(),
};

export const reducer = createReducer(actions, {
  [actions.update]: (s, { meta }) => ({
    ...s,
    entities: (s.entities || []).map((i) => (i.id === meta.id ? meta : i)),
  }),
  [actions.updateField]: (s, { meta }) => ({
    ...s,
    fields: s.fields.map((f) => (f.id === meta.id ? { ...f, ...meta } : f)),
  }),
  [actions.del]: (s, { meta }) => ({
    ...s,
    entities: (s.entities || []).filter((i) => i.id !== meta.id),
  }),
});
